<template>
  <div class="links">
    <div v-qa="'title_links'" class="links__title sf-fr sf-sb" @click="toggle">
      <slot name="title"/>
      <div v-qa="'links_caret'" :class="{ opened }" class="links__caret"/>
    </div>
    <sf-slide-toggle v-model="opened" v-qa="'links_list'" class="links__list">
      <slot/>
    </sf-slide-toggle>
  </div>
</template>

<script>
export default {
  data: () => ({
    opened: false,
  }),
  methods: {
    toggle() {
      this.opened = !this.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
.links {
  @include mobile {
    @include contentGrid;
    padding: 20px 0 0;
    border-bottom: 1px solid map-get($colors, border);

    &:first-child {
      border-top: 1px solid map-get($colors, border);
    }

    &:last-child {
      border: none;
    }
  }

  &__title {
    padding-bottom: 20px;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 600;
    color: map-get($colors, white);
  }

  &__caret {
    margin-right: 2px;
    transform: rotate(45deg);
    transition: all 0.3s ease-in-out;
    border: solid map-get($colors, secondary);
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;

    @include tablet {
      display: none;
    }

    &.opened {
      transform: rotate(-135deg);
      border-color: map-get($colors, white);
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
  }
}
</style>
